import React from 'react';
import { Search } from 'lucide-react';

const CandidatFilters = ({
  searchTerm,
  setSearchTerm,
  selectedSession,
  setSelectedSession,
  selectedStatut,
  setSelectedStatut,
  sessions,
  statutOptions,
  totalCandidats
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
          <input
            type="text"
            placeholder="Rechercher un candidat..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#202654] focus:border-transparent"
          />
        </div>

        <select
          value={selectedSession}
          onChange={(e) => setSelectedSession(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#202654] focus:border-transparent"
        >
          <option value="">Toutes les sessions</option>
          {sessions.map(session => (
            <option key={session.id} value={session.id}>
              {session.nom}
            </option>
          ))}
        </select>

        <select
          value={selectedStatut}
          onChange={(e) => setSelectedStatut(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#202654] focus:border-transparent"
        >
          {statutOptions.map(statut => (
            <option key={statut.value} value={statut.value}>
              {statut.label}
            </option>
          ))}
        </select>

        <div className="text-sm text-gray-500 py-2">
          Total: {totalCandidats} candidat(s)
        </div>
      </div>
    </div>
  );
};

export default CandidatFilters; 